export const educationData = [
    {
        id: 2,
        institution: 'All Pakistan Memon Federation (APMF)',
        course: 'Mobile and Web Application Development',
        startYear: '2017',
        endYear: '2019'
    },
    {
        id: 1,
        institution: 'University of Karachi',
        course: 'Bechlors in Software Engineering',
        startYear: '2016',
        endYear: '2019'
    },
    {
        id: 3,
        institution: 'Sindh Muslim Collage',
        course: 'Intermediate Education',
        startYear: '2013',
        endYear: '2015'
    },
    {
        id: 4,
        institution: 'Bilal Grammar Secondary School',
        course: 'School of thoughts and Matriculation',
        startYear: '2010',
        endYear: '2013'
    },
]